import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
// eslint-disable-next-line no-unused-vars
import _deleteModalStyles from './delete.module.css';
import styles from './statusChange.module.css';
// eslint-disable-next-line no-unused-vars
import _viewStudentStyles from './viewStudent.module.css';
// eslint-disable-next-line no-unused-vars
import _rejectComplaintStyles from './reject_complaint.module.css';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { style } from '@mui/system';

const MarkAsResolvedModal = ({ open, onClose, onConfirm, complaint }) => {
  const [remark, setRemark] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const getApprovedByFromToken = () => {
    try {
      const token = Cookies.get('Token');
      if (!token) return 'Not Available (N/A)';

      const tokenParts = token.split('.');
      if (tokenParts.length < 2) return 'Not Available (N/A)';

      const base64Url = tokenParts[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
      const payload = JSON.parse(atob(padded));

      const firstName = payload?.firstName || '';
      const lastName = payload?.lastName || '';
      const role = payload?.role || '';
      const fullName = `${firstName} ${lastName}`.trim();

      if (!fullName && !role) return 'Not Available (N/A)';
      if (fullName && role) return `${fullName}-${role}`;
      return fullName || role;
    } catch (err) {
      console.error('Failed to decode token payload:', err);
      return 'Not Available (N/A)';
    }
  };

  const approvedBy = getApprovedByFromToken();

  console.log('complaint in status change', complaint);
  console.log('StatusChange modal open:', open);

  // const handleVerify = async () => {
  //   const code = otp.join('');
  //   if (code.length !== OTP_LENGTH) {
  //     toast.error('Please enter full OTP');
  //     return;
  //   }
  //   try {
  //     // TODO: verify OTP via API
  //     toast.success('OTP verified');
  //   } catch (e) {
  //     toast.error('Invalid OTP');
  //   }
  // };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const complaintId = complaint?.complaintId
      
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/hospital/complaint/resolve`,
        {
          complaintId,
          remark
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }
        }
      );
      toast.success(response?.data?.message || 'The complaint has been successfully Resolved.');
      onConfirm?.();
      // Don't close automatically, let the parent handle it
    } catch (error) {
      // toast.error('Invalid OTP');
      toast.error(error.response.data.message || error.response.data.messeage || 'Something went wrong please retry');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    console.log('StatusChange modal closing');
    setRemark('');
    onClose();
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth className={styles.statusChangeModal}>
      {/* Header */}
      <DialogTitle className={styles.modalHeader}>
        <Typography variant="h6" className={styles.modalTitle}>
          OTP Verified
        </Typography>
        <IconButton onClick={handleClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent className={styles.modalContent}>
        <Box className={styles.resolveNotice}>
          <Typography className={styles.resolveNoticeText}>
            The complainant has confirmed the resolution. Please add your remarks below.
          </Typography>
          <Typography className={styles.resolveNoticeSub}>
            Status will be changed to: <span className={styles.resolvedStatusSpan}>Resolved</span>
          </Typography>
        </Box>

        <Box className={styles.formField}>
          <Typography variant="body2" className={styles.fieldLabel}>
            Approved by
          </Typography>
          <TextField
            fullWidth
            value={approvedBy}
            className={styles.approvedByInput}
            size="small"
            disabled
          />
        </Box>

        <Box className={styles.formField}>
          <Typography variant="body2" className={styles.fieldLabel}>
            Remark<span className={styles.requiredMark}>*</span>
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Enter resolution details and any additional notes..."
            className={styles.remarkField}
            size="small"
          />
        </Box>
      </DialogContent>

      {/* Actions */}
      <DialogActions className={styles.modalActions}>
        <Button onClick={handleClose} variant="outlined" className={styles.cancelButton} disabled={isLoading}>
          Back
        </Button>
        <Button onClick={handleSave} variant="contained" className={styles.saveButton} disabled={isLoading || !remark.trim()}>
          {isLoading ? 'Loading...' : 'Mark as Resolved'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkAsResolvedModal;
